/*=====================================
    提示視窗

    Author: Gray
    createtime: 2017 / 12 / 12
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from "actions/creators";
import { DialogStyle } from 'stylecomponents';

/*--------------------------
    Main Component
--------------------------*/
class AlartDialog extends Component {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.closeDialog = this.closeDialog.bind(this);
        this.confirm = this.confirm.bind(this);
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount() {}

    // ------------------------------
    // 關閉
    // ------------------------------
    closeDialog() {

        this.props.webActions.closeAlartDialog();
    }

    // ------------------------------
    // 確認
    // ------------------------------
    confirm() {

        this.props.alartDialog.callback && this.props.alartDialog.callback();
        this.closeDialog();
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const {
            alartDialog,
        } = this.props;

        const {
            title,
            description,
            confirmName,
        } = alartDialog;

        return (
            <DialogStyle.Content
                className="alert-modal"
                // style props
                maxWidth="320px"
                padding="30px"
                backgroundColor="#fff"
                borderRadius="3px"
                // dialog props
                visible={true}
                animation="zoom"
                maskAnimation="fade"
                closable={false}
                maskClosable={false}
                keyboard={false}
                onClose={this.confirm}
            >
                <div className="title">
                    {title}
                </div>
                <div className="description">
                    {description}
                </div>
                <div className="button-group">
                    <div className="button blue submit" onClick={this.confirm}>
                        {confirmName ? confirmName : '確定'}
                    </div>
                </div>
            </DialogStyle.Content>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        alartDialog: state.web.alartDialog,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(AlartDialog);



// WEBPACK FOOTER //
// ./src/components/dialog/AlartDialog.jsx